export const userUidSelector = ({userUid}) => userUid